export default function (details?: DeliveryDetailsI | null): DeliveryDetailsI {
  return {
    id: details?.id || '',
    user: details?.user || '',
    title: details?.title || '',
    name: details?.name || '',
    country: details?.country || '',
    city: details?.city || '',
    zipCode: details?.zipCode || '',
    address: details?.address || '',
    phone: details?.phone || '',
    comment: details?.comment || '',
    vat: details?.vat || '',
  };
}
